define(['jquery', 'jquery.transit', 'modernizr', 'container', 'router', 'jump', 'preloader'],
    function ($, transit, modernizr, container, router, jumpFactory, preloader) {

        return (function () {

            const name = 'legal';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const jump = jumpFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {};

            view.startup = function () {

            };

            view.bind = function () {
                const legalLinkListItemWrapper = document.querySelectorAll(view.publicVars.cssId.legalLinkListItemWrapperCls);
                const legalButtonBackToTop = document.querySelector(view.publicVars.cssId.legalButtonBackToTopCls);

                if(legalButtonBackToTop) {
                    legalButtonBackToTop.addEventListener('click', function () {
                        view.methods.moveToTop();
                    });
                }

                for (legalLink of legalLinkListItemWrapper) {

                    const legalLinkId = legalLink.dataset.id;

                    legalLink.addEventListener('click', function () {
                        view.methods.moveToLegalSection(legalLinkId);
                    });
                }


            };

            view.methods = {
                moveToLegalSection: (legalLinkId) => {
                    const speed = 300 + (50 * legalLinkId);
                    const modifier = -15;

                    jump.jumpTo(view.publicVars.cssId.legalContentHeaderId + legalLinkId, { speed, modifier, easing: 'swing' });
                },

                moveToTop: () => {
                    jump.jumpTo(view.publicVars.cssId.moduleLegalId, { easing: 'swing' });
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
